export default __webpack_public_path__ + "static/media/Ymirish Frostband.9b8657ce.jpg";